import { render, staticRenderFns } from "./MStoreDocumentHistoryTab.vue?vue&type=template&id=27d79440&"
import script from "./MStoreDocumentHistoryTab.vue?vue&type=script&lang=ts&"
export * from "./MStoreDocumentHistoryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports